import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: "radio",
    FormItemProps: {
      label: '单选框',
      name: uuid,
    },
    ControlProps: {
      options: [
        { label: "选项一", value: "1" },
        { label: "选项二", value: "2" }
      ],
    },
  }
}
